import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const HomeTopWidget = ({ icon: Icon, number, title, color = 'orange', linkTo }) => {
    const colorClasses = {
        orange: 'widget-orange',
        green: 'widget-green',
        blue: 'widget-blue',
        purple: 'widget-purple'
    };

    const content = (
        <>
            <div className="stat-widget-icon">
                <Icon size={24} strokeWidth={2} />
            </div>
            <div className="stat-widget-content">
                <h3 className="stat-widget-number">{number}</h3>
                <p className="stat-widget-label">{title}</p>
            </div>
            {linkTo && (
                <div className="stat-widget-arrow">
                    <ChevronRight size={20} />
                </div>
            )}
        </>
    );

    if (linkTo) {
        return (
            <Link to={linkTo} className={`home-stat-widget ${colorClasses[color]} clickable`}>
                {content}
            </Link>
        );
    }

    return (
        <div className={`home-stat-widget ${colorClasses[color]}`}>
            {content}
        </div>
    );
};

export default HomeTopWidget;
